import SpinView from '@/views/spin/SpinView.vue';

export default [
  {
    path: '',
    redirect: { path: 'spin-view' },
  },
  {
    path: 'spin-view',
    component: SpinView,
    meta: {
      headerIcon: 'home',
      headerStyleClasses: 'mb-0',
    },
  },
  {
    path: '*',
    redirect: { path: 'spin-view' },
  },
];
